module.exports = __webpack_public_path__ + "img/rite.8ecaf391.png";